import { render, staticRenderFns } from "./BFormSpinbuttonInput.vue?vue&type=template&id=4ba9e285&scoped=true&"
import script from "./BFormSpinbuttonInput.vue?vue&type=script&lang=js&"
export * from "./BFormSpinbuttonInput.vue?vue&type=script&lang=js&"
import style0 from "./BFormSpinbuttonInput.vue?vue&type=style&index=0&id=4ba9e285&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba9e285",
  null
  
)

export default component.exports